/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { PhoneDetails } from './PhoneDetails';
import {
  PhoneDetailsFromJSON,
  PhoneDetailsFromJSONTyped,
  PhoneDetailsToJSON,
} from './PhoneDetails';
import type { EmailDetails } from './EmailDetails';
import {
  EmailDetailsFromJSON,
  EmailDetailsFromJSONTyped,
  EmailDetailsToJSON,
} from './EmailDetails';
import type { Address } from './Address';
import {
  AddressFromJSON,
  AddressFromJSONTyped,
  AddressToJSON,
} from './Address';

/**
 *
 * @export
 * @interface Lead
 */
export interface Lead {
  /**
   * List of addresses
   * @type {Array<Address>}
   * @memberof Lead
   */
  addresses?: Array<Address>;
  /**
   *
   * @type {number}
   * @memberof Lead
   */
  companyId: number;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  contactId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  contactType?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  csvId?: string | null;
  /**
   *
   * @type {number | null}
   * @memberof Lead
   */
  csvLine?: number | null;
  /**
   *
   * @type {object}
   * @memberof Lead
   */
  custom?: object;
  /**
   *
   * @type {number}
   * @memberof Lead
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Lead
   */
  dateFirstContacted?: number;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  dateFirstContactedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Lead
   */
  dateLastContacted?: number;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  dateLastContactedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Lead
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  department?: string | null;
  /**
   * List of email details
   * @type {Array<EmailDetails>}
   * @memberof Lead
   */
  emails?: Array<EmailDetails>;
  /**
   *
   * @type {number | null}
   * @memberof Lead
   */
  engagementScore?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  externalId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  firstName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  homePhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  imageUrl?: string;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  industry?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  jobTitle?: string | null;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  key: string;
  /**
   * 2-letter country code
   * @type {string | null}
   * @memberof Lead
   */
  lang?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  lastMedium?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  lastName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  leadCompanyId?: string | null;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  leadId?: string;
  /**
   *
   * @type {number | null}
   * @memberof Lead
   */
  leadScore?: number | null;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  leadSource?: LeadLeadSourceEnum;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  mobilePhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  name?: string;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  ownerId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  ownerType?: string | null;
  /**
   * List of phone details
   * @type {Array<PhoneDetails>}
   * @memberof Lead
   */
  phones?: Array<PhoneDetails>;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  preferredMedium?: string | null;
  /**
   * The first address in Lead.addresses as a JSON string in spanner
   * @type {object | null}
   * @memberof Lead
   */
  primaryAddress?: object | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  primaryEmail?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  primaryPhone?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  remoteId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  role?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  secondaryEmail?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Lead
   */
  secondaryPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  state?: LeadStateEnum;
  /**
   *
   * @type {Array<any>}
   * @memberof Lead
   */
  tags?: Array<any>;
  /**
   * e.g. 'US/Pacific', 'UTC', etc
   * @type {string | null}
   * @memberof Lead
   */
  timezone?: string | null;
}

/**
 * @export
 */
export const LeadLeadSourceEnum = {
  Hubspot: 'hubspot',
  Csv: 'csv',
} as const;
export type LeadLeadSourceEnum =
  (typeof LeadLeadSourceEnum)[keyof typeof LeadLeadSourceEnum];

/**
 * @export
 */
export const LeadStateEnum = {
  Pending: 'pending',
  Active: 'active',
  Deleted: 'deleted',
} as const;
export type LeadStateEnum = (typeof LeadStateEnum)[keyof typeof LeadStateEnum];

/**
 * Check if a given object implements the Lead interface.
 */
export function instanceOfLead(value: object): value is Lead {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function LeadFromJSON(json: any): Lead {
  return LeadFromJSONTyped(json, false);
}

export function LeadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Lead {
  if (json == null) {
    return json;
  }
  return {
    addresses:
      json['addresses'] == null
        ? undefined
        : (json['addresses'] as Array<any>).map(AddressFromJSON),
    companyId: json['company_id'],
    contactId: json['contact_id'] == null ? undefined : json['contact_id'],
    contactType:
      json['contact_type'] == null ? undefined : json['contact_type'],
    csvId: json['csv_id'] == null ? undefined : json['csv_id'],
    csvLine: json['csv_line'] == null ? undefined : json['csv_line'],
    custom: json['custom'] == null ? undefined : json['custom'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateFirstContacted:
      json['date_first_contacted'] == null
        ? undefined
        : json['date_first_contacted'],
    dateFirstContactedIso:
      json['date_first_contacted_iso'] == null
        ? undefined
        : json['date_first_contacted_iso'],
    dateLastContacted:
      json['date_last_contacted'] == null
        ? undefined
        : json['date_last_contacted'],
    dateLastContactedIso:
      json['date_last_contacted_iso'] == null
        ? undefined
        : json['date_last_contacted_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    department: json['department'] == null ? undefined : json['department'],
    emails:
      json['emails'] == null
        ? undefined
        : (json['emails'] as Array<any>).map(EmailDetailsFromJSON),
    engagementScore:
      json['engagement_score'] == null ? undefined : json['engagement_score'],
    externalId: json['external_id'] == null ? undefined : json['external_id'],
    firstName: json['first_name'] == null ? undefined : json['first_name'],
    homePhone: json['home_phone'] == null ? undefined : json['home_phone'],
    id: json['id'],
    imageUrl: json['image_url'] == null ? undefined : json['image_url'],
    industry: json['industry'] == null ? undefined : json['industry'],
    jobTitle: json['job_title'] == null ? undefined : json['job_title'],
    key: json['key'],
    lang: json['lang'] == null ? undefined : json['lang'],
    lastMedium: json['last_medium'] == null ? undefined : json['last_medium'],
    lastName: json['last_name'] == null ? undefined : json['last_name'],
    leadCompanyId:
      json['lead_company_id'] == null ? undefined : json['lead_company_id'],
    leadId: json['lead_id'] == null ? undefined : json['lead_id'],
    leadScore: json['lead_score'] == null ? undefined : json['lead_score'],
    leadSource: json['lead_source'] == null ? undefined : json['lead_source'],
    mobilePhone:
      json['mobile_phone'] == null ? undefined : json['mobile_phone'],
    name: json['name'] == null ? undefined : json['name'],
    ownerId: json['owner_id'] == null ? undefined : json['owner_id'],
    ownerType: json['owner_type'] == null ? undefined : json['owner_type'],
    phones:
      json['phones'] == null
        ? undefined
        : (json['phones'] as Array<any>).map(PhoneDetailsFromJSON),
    preferredMedium:
      json['preferred_medium'] == null ? undefined : json['preferred_medium'],
    primaryAddress:
      json['primary_address'] == null ? undefined : json['primary_address'],
    primaryEmail:
      json['primary_email'] == null ? undefined : json['primary_email'],
    primaryPhone:
      json['primary_phone'] == null ? undefined : json['primary_phone'],
    remoteId: json['remote_id'] == null ? undefined : json['remote_id'],
    role: json['role'] == null ? undefined : json['role'],
    secondaryEmail:
      json['secondary_email'] == null ? undefined : json['secondary_email'],
    secondaryPhone:
      json['secondary_phone'] == null ? undefined : json['secondary_phone'],
    state: json['state'] == null ? undefined : json['state'],
    tags: json['tags'] == null ? undefined : json['tags'],
    timezone: json['timezone'] == null ? undefined : json['timezone'],
  };
}

export function LeadToJSON(value?: Lead | null): any {
  if (value == null) {
    return value;
  }
  return {
    addresses:
      value['addresses'] == null
        ? undefined
        : (value['addresses'] as Array<any>).map(AddressToJSON),
    company_id: value['companyId'],
    contact_id: value['contactId'],
    contact_type: value['contactType'],
    csv_id: value['csvId'],
    csv_line: value['csvLine'],
    custom: value['custom'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_first_contacted: value['dateFirstContacted'],
    date_first_contacted_iso: value['dateFirstContactedIso'],
    date_last_contacted: value['dateLastContacted'],
    date_last_contacted_iso: value['dateLastContactedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    department: value['department'],
    emails:
      value['emails'] == null
        ? undefined
        : (value['emails'] as Array<any>).map(EmailDetailsToJSON),
    engagement_score: value['engagementScore'],
    external_id: value['externalId'],
    first_name: value['firstName'],
    home_phone: value['homePhone'],
    id: value['id'],
    image_url: value['imageUrl'],
    industry: value['industry'],
    job_title: value['jobTitle'],
    key: value['key'],
    lang: value['lang'],
    last_medium: value['lastMedium'],
    last_name: value['lastName'],
    lead_company_id: value['leadCompanyId'],
    lead_id: value['leadId'],
    lead_score: value['leadScore'],
    lead_source: value['leadSource'],
    mobile_phone: value['mobilePhone'],
    name: value['name'],
    owner_id: value['ownerId'],
    owner_type: value['ownerType'],
    phones:
      value['phones'] == null
        ? undefined
        : (value['phones'] as Array<any>).map(PhoneDetailsToJSON),
    preferred_medium: value['preferredMedium'],
    primary_address: value['primaryAddress'],
    primary_email: value['primaryEmail'],
    primary_phone: value['primaryPhone'],
    remote_id: value['remoteId'],
    role: value['role'],
    secondary_email: value['secondaryEmail'],
    secondary_phone: value['secondaryPhone'],
    state: value['state'],
    tags: value['tags'],
    timezone: value['timezone'],
  };
}
